<!-- <ng-container [ngTemplateOutlet]="content.templateRef"></ng-container> -->
<div class="editor-submenu">
    <!-- <div class="editor-heading" *ngIf="state != 'compacted';else compacted">
            <span >{{title}}</span>
            <nb-icon class="toggle-icon" icon="angle-double-right" pack="fas" (click)="toggleSideBar($event)"></nb-icon>
    </div>
    <ng-template #compacted>
        <nb-icon class="toggle-icon" icon="angle-double-left" pack="fas" (click)="toggleSideBar($event)"></nb-icon>
    </ng-template> -->
    <div class="editor-heading">
        <span>{{title}}</span>
    </div>
    <div class="editor-heading status">
        <div class="current">Status:<span>&nbsp;{{status}}</span></div>
        <div class="input-cell">
            <nb-actions size="small">
                <nb-action (click)="onSave()" [disabled]="!canSave">
                    <nb-icon icon="save-outline" pack="eva"></nb-icon>
                    <span>Save</span>
                </nb-action>
                <nb-action (click)="onPublish()" [disabled]="status==='Published'">
                    <nb-icon icon="edit-outline" pack="eva"></nb-icon>
                    <span>Publishing</span>
                </nb-action>
            </nb-actions>
        </div>
    </div>
    <div class="editor-wrapper">
        <div class="edit-container">
            <kv-editor-input-container [inputComponent]="inputComponent"
                [menuGroups]="menuGroups"></kv-editor-input-container>
        </div>
        <div class="sub-menu-container">
            <nb-menu class="editor-menu" [items]="menuItems" tag="{{menuTag}}"></nb-menu>
        </div>

    </div>
</div>